import { useEffect } from 'react'
import { toast } from 'sonner'

/** Time between two checks for a new version of the service worker. */
export const INTERVALO_CHEQUEO_MS = 5 * 60 * 1000

/**
 * Tells the user when a new version of the app took control of this tab.
 * The first controller change of a tab without a controller is the first install, so it is ignored. Every later change is a new version.
 * The page never reloads by itself, so nothing the user is typing is lost.
 * The service worker is checked on an interval and when the tab becomes visible again.
 */
export function AvisoVersionNueva(): null {
  useEffect(() => {
    const sw = navigator.serviceWorker
    if (!sw) return

    let teniaController = !!sw.controller
    const alCambiar = () => {
      if (!teniaController) {
        teniaController = true
        return
      }
      toast('Hay una versión nueva de Menta. Recargá la página antes de seguir; lo que no guardaste se pierde.', {
        id: 'version-nueva',
        duration: Infinity,
        action: { label: 'Recargar', onClick: () => window.location.reload() },
      })
    }
    const chequear = () => {
      sw.getRegistration()
        .then((r) => r?.update())
        .catch(() => undefined)
    }
    const alVolver = () => {
      if (document.visibilityState === 'visible') chequear()
    }

    sw.addEventListener('controllerchange', alCambiar)
    document.addEventListener('visibilitychange', alVolver)
    const intervalo = window.setInterval(chequear, INTERVALO_CHEQUEO_MS)
    return () => {
      sw.removeEventListener('controllerchange', alCambiar)
      document.removeEventListener('visibilitychange', alVolver)
      window.clearInterval(intervalo)
    }
  }, [])

  return null
}
